import { ResponseException } from "../../../../Exceptions";
import { downloadFile } from "../../../download";
import { request } from "../../api";

export async function getSummary1({ province, month, year }) {
    const response = await request("GET /data/sameday/published/summary1", { query: { province, month, year } });
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

export async function downloadMonthlyLGUReport({ month, year, lgu, filename }) {
    const response = await request(`GET /data/sameday/published/export/lgu-monthly`, 
        { query: { month, year, lgu }, parsing: "blob" });
        
    if(response.ok) return downloadFile(filename, response.data);
    
    throw new ResponseException(response);
}

export async function downloadAnnualAttractionReport({ attraction, year, filename }) {
    const response = await request(`GET /data/sameday/published/export/attraction-annual`, 
        { query: { attraction, year }, parsing: "blob" });
        
    if(response.ok) return downloadFile(filename, response.data);
    
    throw new ResponseException(response);
}

export async function downloadAnnualReport({ year, filename }) {
    const response = await request(`GET /data/sameday/published/export/all-annual`, 
        { query: { year }, parsing: "blob" });
        
    if(response.ok) return downloadFile(filename, response.data);
    
    throw new ResponseException(response);
}